import React from 'react';
import {
  FontWeights,
  Typography,
} from '~/components/shared/Typography/Typography';
import { StyledIcon, SvgSrc } from '~/components/shared/Icon/Icon';
import styled from 'styled-components';
import useTranslate from '~/hooks/useTranslate';
import {
  PaymentMethodBodyContainer,
  PaymentMethodHeaderContainer,
  PaymentMethodMainContainer,
  StepCircle,
} from '../Invoice';
import PaymentMethodsHeader from './PaymentMethods/PaymentMethodsHeader';
import { Link } from './PaymentMethods/Instalments/InstalmentCards';

export const ErrorIcon = styled.div`
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  max-width: 27px;
  max-height: 27px;
`;
export const RedCircle = styled.div`
  width: 80px
  height: 80px;
  border: 2px solid #EB4C6A;
  border-radius: 50%;
  display: table;
  margin: auto;
  `;

export const TryAgainContainer = styled.div`
  width: 100%;
  cursor: pointer;
  margin: auto;
  margin-top: 25px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TryAgainButton = styled.button`
  width: 100%;
  color: white;
  background-color: #214749
  border: none;
  border-radius: 10px;
  height: 47px;
  margin: auto;
  margin-top: 80px;
  max-width: 310px;
  `;
export const TryAgainMessage = styled.span`
  display: inline;
  font-size: 18px;
`;
export const ContactSupportLink = styled(Link)`
  display: inline;
  font-size: 18px;
`;

interface Props {
  onTryAgain: () => void;
}

const SomethingWentWrong: React.FC<Props> = (props) => {
  const { onTryAgain } = props;

  const translate = useTranslate();

  return (
    <PaymentMethodMainContainer>
      <PaymentMethodsHeader hideCancelButton />
      <PaymentMethodBodyContainer>
        <PaymentMethodHeaderContainer withSubtext>
          <Typography
            lineHeight={1.8}
            fontSize={1.2}
            color="#444444"
            fontWeight={FontWeights.Bold}
          >
            <StepCircle green />
            <StepCircle green />
            <StepCircle green />
            <StepCircle green />
            <RedCircle>
              <ErrorIcon>
                <StyledIcon
                  color="#EB4C6A"
                  icon={SvgSrc.WarningCircle}
                  style={{
                    minWidth: '27px',
                    minHeight: '27px',
                    verticalAlign: 'middle',
                  }}
                />
              </ErrorIcon>
            </RedCircle>
            <br />
            {translate('Invoices.SomethingWentWrong')}
          </Typography>
        </PaymentMethodHeaderContainer>
        <TryAgainContainer>
          <div>
            <TryAgainMessage>
              {translate('Invoices.ProcessNotCompleted')}
            </TryAgainMessage>
            {/* eslint-disable-next-line */}
            <ContactSupportLink href="https://www.qred.com/sv-se/support">
              {' '}
              {translate('Invoices.ContactSupport')}.
            </ContactSupportLink>
          </div>
          <TryAgainButton onClick={onTryAgain}>
            {translate('Invoices.TryAgain')}
          </TryAgainButton>
        </TryAgainContainer>
      </PaymentMethodBodyContainer>
    </PaymentMethodMainContainer>
  );
};

export default SomethingWentWrong;
